"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _lhJsCommonLib = require("@lifehikes/lh-js-common-lib");
var _hike = require("@/api/hike");
var _moment = _interopRequireDefault(require("moment"));
var _filters = require("@/filters");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeFeedbackResult',
  components: {},
  directives: {},
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getHike();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      firstTab: 'stage1',
      hike: null,
      hikeStages: [{
        id: "ffddd"
      }, {
        id: "ffddd3"
      }],
      feedbackResults: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  methods: {
    handleSuccess: function handleSuccess(_ref) {
      var results = _ref.results,
        header = _ref.header;
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          hikeId: _lodash.default.trim(r.hikeId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.familyName),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    getHike: function getHike() {
      var _this2 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      return (0, _hike.getHikeById)(token, id).then(function (response) {
        _this2.hike = response.data;
        _this2.hikeStages = _this2.hike.stages;

        // No stages, show Post Program Feedback tab
        if (_this2.hikeStages.length == 0) {
          _this2.firstTab = 'postProgramFeedback';
        }
        //

        _this2.$set(_this2, 'hike', response.data);
        _this2.$set(_this2, 'hikeStages', _this2.hike.stages);
        _this2.hike.stages.forEach(function (item, index) {
          console.info("stage id:" + item.id);
          _this2.getHikeFeedbackResults(item.id, 'stage' + (index + 1));
        });
        _this2.getPostProgramFeedbackResults();
        _this2.loading = false;
        return _this2.hike;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getPostProgramFeedbackResults: function getPostProgramFeedbackResults() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, hikeId, linkedResource;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              hikeId = typeof _this3.$route.params.id === 'undefined' ? '' : _this3.$route.params.id;
              linkedResource = (0, _lhJsCommonLib.formatLhrn)('hike', hikeId, 'postprogramfeedback');
              _context2.n = 1;
              return (0, _hike.getFeedbackResults)(token, hikeId, null, linkedResource).then(function (response) {
                var results = [];
                var _iterator = (0, _createForOfIteratorHelper2.default)(response.data),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var result = _step.value;
                    var date = _moment.default.utc(result.completeTimeUtc);
                    result.completeTimeUtc = date.format('YYYY-MM-DD HH:mm:ss');
                    // result.stageId = stageId;
                    result.stageName = 'postProgramFeedback';
                    // result.stageIndex = stageName.toString().replace('stage', '');
                    results.push(result);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                var newItem = _this3.feedbackResults.concat(results);
                _this3.$set(_this3, 'feedbackResults', newItem);
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getPostProgramFeedbackResults-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getHikeFeedbackResults: function getHikeFeedbackResults(stageId, stageName) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token, hikeId;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              hikeId = typeof _this4.$route.params.id === 'undefined' ? '' : _this4.$route.params.id;
              _context3.n = 1;
              return (0, _hike.getFeedbackResults)(token, hikeId, stageId).then(function (response) {
                var results = [];
                var _iterator2 = (0, _createForOfIteratorHelper2.default)(response.data),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var result = _step2.value;
                    var date = _moment.default.utc(result.completeTimeUtc);
                    result.completeTimeUtc = date.format('YYYY-MM-DD HH:mm:ss');
                    result.stageId = stageId;
                    result.stageName = stageName;
                    result.stageIndex = stageName.toString().replace('stage', '');
                    results.push(result);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                var newItem = _this4.feedbackResults.concat(results);
                _this4.$set(_this4, 'feedbackResults', newItem);
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getHikeFeedbackResults-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    onStageBtnClicked: function onStageBtnClicked(tab, event) {
      // Ref https://stackoverflow.com/questions/54938719/how-to-get-key-value-in-tab-element-ui
      var index = tab.$vnode.key;
      // const stageId = this.hikeStages[index].id
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/edit/".concat(id));
    },
    downloadHikeFeedBack: function downloadHikeFeedBack() {
      var excelHeader = ['Stage', 'Participant ID', 'Name', 'Question', 'Answer', 'Complete time (UTC)'];
      var hikeFeedBackData = [];
      var exportData = _lodash.default.cloneDeep(this.feedbackResults.filter(function (result) {
        return result.stageName !== 'postProgramFeedback';
      }));
      exportData = _lodash.default.sortBy(exportData, ['stageIndex'], ['asc']);
      exportData.forEach(function (feedback, index) {
        feedback.answers.forEach(function (answer, answerIdx) {
          var data = [feedback.stageIndex, feedback.participantUuid, feedback.participantGivenName + ' ' + feedback.participantFamilyName, answer.questionText, answer.answer, feedback.completeTimeUtc];
          hikeFeedBackData.push(data);
        });
      });
      // Export to excel
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        excel.export_json_to_excel({
          header: excelHeader,
          data: hikeFeedBackData,
          filename: 'hike_feedback_export',
          bookType: 'csv'
        });
      });
    },
    downloadPostProgramFeedBack: function downloadPostProgramFeedBack() {
      var excelHeader = ['Participant Email', 'Question', 'Answer', 'Complete time (UTC)'];
      var feedbackData = [];
      var exportData = _lodash.default.cloneDeep(this.feedbackResults.filter(function (result) {
        return result.stageName === 'postProgramFeedback';
      }));
      exportData.forEach(function (feedback, index) {
        feedback.answers.forEach(function (answer, answerIdx) {
          var data = [feedback.fillerEmail ? feedback.fillerEmail : 'N/A (Anonymous)', answer.questionText, answer.answer, feedback.completeTimeUtc];
          feedbackData.push(data);
        });
      });
      // Export to excel
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        excel.export_json_to_excel({
          header: excelHeader,
          data: feedbackData,
          filename: 'post_program_feedback_export',
          bookType: 'csv'
        });
      });
    }
  }
};